import lodash from 'lodash';

function decodeExportValue(key: string, value: unknown) {
  if (key !== 'fileName' || typeof value !== 'string' || !value.includes('%')) {
    return value;
  }

  try {
    // Upload records may store percent-encoded filenames; decode once for exports only.
    return decodeURIComponent(value);
  } catch (error) {
    console.warn('Failed to decode export fileName:', value, error);
    return value;
  }
}

/**
 * 将 JSON 数据导出为 CSV 文件
 * @param jsonArray
 * @param keyMap
 */
export function downloadToCsv(jsonArray: object[], keyMap: object, fileName = '下载') {
  // \uFEFF 是为解决中文乱码问题
  let csvContent = 'data:text/csv;charset=utf-8,\uFEFF';

  if (jsonArray && jsonArray.length) {
    const mappedKeys = Object.keys(keyMap || {}).filter((key) => !key.startsWith('_'));
    const dataKeys = lodash.uniq(
      lodash.flatten(
        jsonArray.map((rowData) => {
          return Object.keys(rowData);
        }),
      ),
    );
    // Keep declared export columns even when every row omits a nullable field.
    const keys = lodash.uniq([...mappedKeys, ...dataKeys]);
    jsonArray.forEach((rowData: any, index: number) => {
      if (index === 0) {
        // 第一行，保存字段头信息
        const headerRow = keys
          .map((key) => {
            // @ts-ignore
            return (keyMap && keyMap[key]) || key;
          })
          .join(',');
        csvContent += `${headerRow}\r\n`;
      }
      const row = keys
        .map((key) => {
          const value = decodeExportValue(key, lodash.get(rowData, key, ''));
          // @ts-ignore
          const converter = keyMap['_' + key];
          if (converter) {
            // _ 开头的是转换函数，用于将英文、数字等转换成中文
            return converter(String(value ?? ''));
          } else {
            console.info('no converter', key);
            return JSON.stringify(value ?? '');
          }
        })
        .join(',');
      csvContent += `${row}\r\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const a = document.createElement('a');
    a.href = encodedUri;
    a.target = '_blank';
    a.download = `${fileName}.csv`;
    a.click();
  } else {
    console.error('无数据，无法下载');
  }
}

/**
 * 将 JSON 数据导出为 Excel 文件（.xlsx）
 * xlsx 体积较大，只在导出时按需加载。
 * @param jsonArray
 * @param keyMap
 * @param fileName
 */
export async function downloadToExcel(jsonArray: object[], keyMap: object, fileName = '下载'): Promise<void> {
  if (!jsonArray || jsonArray.length === 0) {
    console.error('无数据，无法下载');
    return;
  }
  const XLSX = await import(/* webpackChunkName: "xlsx" */ 'xlsx');
  const keys = Object.keys(keyMap).filter(k => !k.startsWith('_'));
  const header = keys.map(k => (keyMap as any)[k] || k);
  const data = jsonArray.map(row => keys.map(k => decodeExportValue(k, (row as any)[k])));
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
